export default {
  title: "Overview",
  reported: "Reported by",
  assigned: "Assigned to",
  cost: "Cost liable",
  edit: "Edit Info",
  unspecified: "--",
};
